import React, {useEffect, useState} from "react";
import {observer} from "mobx-react-lite";
import {Tooltip} from "@vkontakte/vkui";
import GameStore from "../../store/game";

// Полоса со статусами игры (таймер, очки, комбо)
export const StatusStrip = observer(() => {
    const timeLeft = Math.max(GameStore.timeLeft || 0, 0);
    const timerTextClass = timeLeft < 10 ? "text-brand-danger" : "text-gray-900";
    const totalTime = GameStore.timeLimitSeconds || 0;
    const progress = totalTime > 0 ? Math.min(Math.max((timeLeft / totalTime) * 100, 0), 100) : 0;
    const totalWords = Array.isArray(GameStore.targetWordLengths) ? GameStore.targetWordLengths.length : 0;
    const foundWords = Array.isArray(GameStore.foundWords) ? GameStore.foundWords.length : 0;
    const wordsProgress = totalWords > 0 ? Math.min((foundWords / totalWords) * 100, 100) : 0;
    const [isComboHelpOpen, setIsComboHelpOpen] = useState(false);

    // Автозакрытие подсказки про комбо
    useEffect(() => {
        if (!isComboHelpOpen) {
            return;
        }

        const timer = setTimeout(() => {
            setIsComboHelpOpen(false);
        }, 7000);

        return () => {
            clearTimeout(timer);
        };
    }, [isComboHelpOpen]);

    return (
        <div className="px-4 flex flex-col gap-3">
            <div className="grid grid-cols-3 gap-2">
                <div className="bg-gray-200 border border-gray-300/50 rounded-xl px-3 py-2 text-center shadow-sm">
                    <div className="text-xs text-gray-700">Таймер</div>
                    <div className={`text-lg font-semibold ${timerTextClass}`}>{timeLeft}с</div>
                    <div className="w-full h-2 bg-gray-300/70 rounded-full overflow-hidden mt-2">
                        <div
                            className="h-full bg-yellow-500 transition-all"
                            style={{width: `${progress}%`}}
                        />
                    </div>
                </div>

                <div className="bg-gray-200 border border-gray-300/50 rounded-xl px-3 py-2 text-center shadow-sm">
                    <div className="text-xs text-gray-700">Счёт</div>
                    <div className="text-lg font-semibold text-gray-900">{GameStore.score}</div>
                    <div className="text-[11px] text-gray-700 mt-1">Лучший: {GameStore.bestScore}</div>
                </div>

                <div className="bg-gray-200 border border-gray-300/50 rounded-xl px-3 py-2 text-center flex flex-col items-center gap-1 shadow-sm">
                    <div className="flex items-center gap-1 text-xs text-gray-700">
                        <span>Комбо</span>
                        <Tooltip
                            text="Комбо растёт за слова подряд без пауз. Если между словами проходит больше 10 секунд, серия обнуляется. Чем выше серия, тем больше очков."
                            isShown={isComboHelpOpen}
                            onClose={() => setIsComboHelpOpen(false)}
                            alignY="bottom"
                            alignX="right"
                            offsetY={8}
                        >
                            <button
                                type="button"
                                className="inline-flex h-4 w-4 items-center justify-center rounded-full border border-gray-500 text-[10px] text-gray-700 hover:text-gray-900 hover:border-gray-700"
                                onClick={() => setIsComboHelpOpen(!isComboHelpOpen)}
                                aria-label="Что такое комбо"
                                aria-expanded={isComboHelpOpen}
                            >
                                ?
                            </button>
                        </Tooltip>
                    </div>
                    <div className="text-lg font-semibold text-gray-900">x{GameStore.comboCount}</div>
                </div>
            </div>

            <div className="bg-gray-200 border border-gray-300/50 rounded-xl px-3 py-2 flex flex-col gap-2 shadow-sm">
                <div className="flex items-center justify-between">
                    <div className="text-sm text-gray-800">Прогресс</div>
                    <div className="text-sm font-semibold text-gray-900">
                        Найдено: {foundWords} из {totalWords}
                    </div>
                </div>
                <div className="w-full h-2 bg-gray-300/70 rounded-full overflow-hidden">
                    <div
                        className="h-full bg-yellow-500 transition-all"
                        style={{width: `${wordsProgress}%`}}
                    />
                </div>
            </div>
        </div>
    );
});
